'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var START_MASKS = [255, 254, 252, 248, 240, 224, 192, 128];
var STOP_MASKS = [1, 3, 7, 15, 31, 63, 127, 255];

module.exports = /*#__PURE__*/function () {
  function ConsumableBuffer(value) {
    _classCallCheck(this, ConsumableBuffer);

    this._value = value;
    this._currentBytePos = value.length - 1;
    this._currentBitPos = 7;
  }

  _createClass(ConsumableBuffer, [{
    key: "availableBits",
    value: function availableBits() {
      return this._currentBitPos + 1 + this._currentBytePos * 8;
    }
  }, {
    key: "totalBits",
    value: function totalBits() {
      return this._value.length * 8;
    }
  }, {
    key: "take",
    value: function take(bits) {
      var pendingBits = bits;
      var result = 0;

      while (pendingBits && this._haveBits()) {
        var byte = this._value[this._currentBytePos];
        var availableBits = this._currentBitPos + 1;
        var taking = Math.min(availableBits, pendingBits);
        var value = byteBitsToInt(byte, availableBits - taking, taking);
        result = (result << taking) + value;
        pendingBits -= taking;
        this._currentBitPos -= taking;

        if (this._currentBitPos < 0) {
          this._currentBitPos = 7;
          this._currentBytePos--;
        }
      }

      return result;
    }
  }, {
    key: "untake",
    value: function untake(bits) {
      this._currentBitPos += bits;

      while (this._currentBitPos > 7) {
        this._currentBitPos -= 8;
        this._currentBytePos += 1;
      }
    }
  }, {
    key: "_haveBits",
    value: function _haveBits() {
      return this._currentBytePos >= 0;
    }
  }]);

  return ConsumableBuffer;
}();

function byteBitsToInt(byte, start, length) {
  var mask = maskFor(start, length);
  return (byte & mask) >>> start;
}

function maskFor(start, length) {
  return START_MASKS[start] & STOP_MASKS[Math.min(length + start - 1, 7)];
}